import DomainModel from './DomainModel'

export default class UserCaseCategory extends DomainModel {
  constructor(private case_category_id: string, private category_name: string, private totalCases: number, private outOfTatCasesCount: number, private outOfTatCases: any, private category_code?: string) {
    super()
  }

  getId = () => this.case_category_id
  getName = () => this.category_name
  getCode = () => this.category_code
  getCasesCount = () => this.totalCases
  getOutOfTatCount = () => this.outOfTatCasesCount
  getOutOfTatCases = () => this.outOfTatCases
}